<!-- 材料管理 -->
<template>
  <div class="container">
    <div class="index" v-if="!setTeacherDetail.show && !openClassDetail.show ">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>
      <div>
        <el-form :inline="true" :model="queryParams">
          <el-form-item label="">
            <el-select
              v-model="queryParams.semester"
              placeholder="选择学年学期"
              class="label"
              clearable
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id + 'semester'"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="">
            <el-select
              v-model="queryParams.state"
              clearable
              placeholder="请选择开课状态"
              class="label"
            >
              <el-option
                v-for="(item, i) in stateList"
                :key="i + 'sh'"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="">
            <el-input
              type="text"
              v-model="queryParams.courseName"
              placeholder="请输入课程名称"
               clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="" style="margin-left:20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
            <el-button size="small" @click="handleExport()">导出</el-button>
          </el-form-item>
        </el-form>

        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="courseName" show-overflow-tooltip label="课程名称" align="center"></el-table-column>
            <el-table-column prop="schoolName" show-overflow-tooltip label="开课学校" align="center"></el-table-column>
            <!-- <el-table-column prop="describe" show-overflow-tooltip label="课程区域" align="center"></el-table-column> -->
            <el-table-column prop="schoolYearSemester" show-overflow-tooltip label="学年学期" align="center"></el-table-column>
            <el-table-column prop="courseTypeName" show-overflow-tooltip label="课程类型" align="center"></el-table-column>
            <!-- <el-table-column prop="stateList" label="课程状态" align="center">
              <template slot-scope="scope">
                <p>{{ stateObj[scope.row.stateList] }}</p>
              </template>
            </el-table-column> -->
            <!-- <el-table-column prop="describe" show-overflow-tooltip label="开课时间" align="center"></el-table-column>
            <el-table-column prop="describe" show-overflow-tooltip label="选课时间" align="center"></el-table-column> -->
            <el-table-column prop="gradeName" show-overflow-tooltip label="招生年级" align="center"></el-table-column> 
            <el-table-column prop="totalLimit" show-overflow-tooltip label="招生人数" align="center"></el-table-column>
            <el-table-column prop="locationName" show-overflow-tooltip label="上课地点" align="center"></el-table-column>
            <el-table-column prop="classTimeName" show-overflow-tooltip label="上课时间" align="center"></el-table-column>
            <el-table-column prop="teacherName" show-overflow-tooltip label="授课老师" align="center"></el-table-column>
            <!-- <el-table-column prop="describe" show-overflow-tooltip label="是否开班" align="center">
                <template slot-scope="scope">
                <p>{{ stateObj[scope.row.stateList] }}</p>
              </template>
            </el-table-column>   -->
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              fixed="right"
              width="200"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
                 <el-button type="text" size="small" @click="handleSetTeacher(scope.row)"
                  >设置教师</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
     <set-teacher :setTeacherDetail="setTeacherDetail"></set-teacher>
     <open-class-detail :openClassDetail="openClassDetail"></open-class-detail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import util from "@/utils/util.js";
export default {
  components: {
    setTeacher: () => import("./setTeacher.vue"),
    openClassDetail: () => import("./openClassDetail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        courseName: "",
        state: "",
      },
      stateList: [
        { id: "0", label: "选课结束" },
        { id: "1", label: "选课中" },
        { id: "2", label: "开课结束" },
      ],
      stateObj: {
        "0": "未送审",
        "1": "待审核",
        "2": "审核通过",
        "3": "审核不通过",
      },
      semesterList: [
        { id: "2021-2022_1", label: "2021-2022 上学期" },
        { id: "2021-2022_2", label: "2021-2022 下学期" },
        { id: "2022-2023_1", label: "2022-2023 上学期" },
        { id: "2022-2023_2", label: "2022-2023 下学期" },
        { id: "2023-2024_1", label: "2023-2024 上学期" },
        { id: "2023-2024_2", label: "2023-2024 下学期" },
      ],
      tableData: [],
      openClassDetail: {
        info: {},
        show: false,
      },
      setTeacherDetail:{
        info: {},
        show: false,
      }
    };
  },
  watch: {
    $route: {
      handler(n, o) {
      },
      immediate: true,
    },
  },
  mounted() {},
  created() {
    this.getDataList();
  },
  methods: {
    init() {
      this.queryParams = {
        grade: "",
        date: "",
        state: "",
      };
      this.pageNum = 1;
      this.getDataList();
    },
    async getDataList() {
      let params = {
        platformCode:'999999',//	是	string	平台码 sessionStorage.getItem('platformCode')
        extOrgId:"b97227d46e0811ec980e020315f3f1bd",//	是	string	外部机构ID
        schoolYearSemester:this.queryParams.semester || "2021-2022_2",//	是	string	学年学期 例如：2021-2022_1
        // orgId:sessionStorage.getItem('orgId'),//	否	string	学校Id 
        courseName:this.queryParams.courseName,//	否	string	课程名称
        searchDate:"2022-03-21",//	否	string	开班日期
        page: this.pageNum,
        limit: this.pageSize,
      };
      let { data, code } = await api.getOrgCourseApplyList(params);
      console.log("机构-开班统计列表", data, code);
      if (code == "0") {
        this.tableData = data?.list || [];
        this.totalPage = data?.total || 0;
      }
    },
       // 导出
    async handleExport() {
          let params = {
         platformCode:'999999',//	是	string	平台码 sessionStorage.getItem('platformCode')
        extOrgId:"b97227d46e0811ec980e020315f3f1bd",//	是	string	外部机构ID
        // orgId:sessionStorage.getItem('orgId'),//	否	string	学校Id 
        courseName:this.queryParams.courseName,//	否	string	课程名称
        searchDate:"",//	否	string	开班日期
        page: this.pageNum,
        limit:9999,
      };
      let { data, code } = await api.getOrgExportCourseApplyList(params);
      if (code == "0") {
          window.open(data,"_self")
          this.$message({
          type: "success",
          message: "导出成功",
        });
      }
    },
    // 设置老师
   async handleSetTeacher(data){
      console.log('点击设置老师--',data);
      this.setTeacherDetail={
        info:data,
        show:true
      }
   },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    async toDetail(data) {
       this.openClassDetail={
         show:true,
         info:data
       }
    //   let params = {
    //     mid: item.mid,
    //   };
    //   var { result, data } = await handleMaterialsDetail(params);
    //   let res = await getAuditrecordList(params);
    //   if (result == "000000") {
    //     this.detail.info = data;
    //     if (res.result === "000000") {
    //       this.detail.info.operateList = res.data || [];
    //     }
    //     this.detail.show = true;
    //   } else {
    //     this.$message({
    //       type: "error",
    //       message: "获取信息失败",
    //     });
    //   }
    },
    toIndex() {
      this.detail.show = false;
    },
  },
};
</script>
<style lang="less">
::v-deep .el-tooltip__popper {
  max-width: 50%;
}
</style>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.index {
  width: 100%;
  height: 100%;
  padding: 0px 30px 30px;
  overflow: auto;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 180px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
